import { render } from "./FrontPageMenu.vue?vue&type=template&id=3517c21c&scoped=true"
import script from "./FrontPageMenu.vue?vue&type=script&lang=js"
export * from "./FrontPageMenu.vue?vue&type=script&lang=js"

import "./FrontPageMenu.vue?vue&type=style&index=0&id=3517c21c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3517c21c"]])

export default __exports__